









import Vue from 'vue';
import BlockContent from 'sanity-blocks-vue-component';
import envs from '@/config/envs';
import SanityVimeoSerializer from './SanityVimeoSerializer.vue';
import SanityYouTubeSerializer from './SanityYouTubeSerializer.vue';
import SanityLoopvideoSerializer from './SanityLoopvideoSerializer.vue';
import SanityCodeBlockSerializer from './SanityCodeBlockSerializer.vue';
import SanityPhotoAlbumSerializer from './SanityPhotoAlbumSerializer.vue';
import SanityRichTextImageSerializer from './SanityRichTextImageSerializer.vue';
import SanityQuoteSerializer from './SanityQuoteSerializer.vue';

export default Vue.extend({
  name: 'SanityBlockContent',
  components: {
    BlockContent,
  },
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      serializers: {
        // Add Sanity serializers here as needed
        types: {
          vimeo: SanityVimeoSerializer,
          youtube: SanityYouTubeSerializer,
          loopvideo: SanityLoopvideoSerializer,
          codeblock: SanityCodeBlockSerializer,
          photoAlbum: SanityPhotoAlbumSerializer,
          richTextImage: SanityRichTextImageSerializer,
          quote: SanityQuoteSerializer,
        },
      },
    };
  },
  computed: {
    sanityProjectId() {
      return envs.sanity.projectId;
    },
    sanityDataset() {
      return envs.sanity.dataset;
    },
  },
});
